import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function RusselMorganEsqPage() {
  return <AttorneyBioTemplate attorney={attorneys['russel-morgan-esq']} />;
}
